// extracted by mini-css-extract-plugin
export var acitonButtons = "_hr-0";
export var additionalIcon = "_hr-f";
export var block = "_hr-1";
export var blockContent = "_hr-7";
export var blockDescription = "_hr-8";
export var blockIcon = "_hr-9";
export var blockTitle = "_hr-6";
export var border = "_hr-a";
export var center = "_hr-l";
export var edge = "_hr-b";
export var edgeLabel = "_hr-c";
export var edgePath = "_hr-d";
export var error = "_hr-e";
export var flowchart = "_hr-g";
export var flowchartContent = "_hr-h";
export var highlighted = "_hr-3";
export var hover = "_hr-4";
export var icon = "_hr-i";
export var left = "_hr-m";
export var navButton = "_hr-j";
export var navButtons = "_hr-k";
export var right = "_hr-n";
export var selected = "_hr-2";
export var small = "_hr-5";